import { useState, useEffect, useRef } from 'react';

// Anima un número desde 0 hasta `end` con easing suave al montar
export const useCountUp = (end, duration = 1200) => {
  const [value, setValue] = useState(0);
  const rafRef = useRef();

  useEffect(() => {
    const target = Number(end) || 0;
    let startTs;
    const step = (ts) => {
      if (!startTs) startTs = ts;
      const progress = Math.min((ts - startTs) / duration, 1);
      const eased = 1 - Math.pow(1 - progress, 3); // easeOutCubic
      setValue(target * eased);
      if (progress < 1) rafRef.current = requestAnimationFrame(step);
    };
    rafRef.current = requestAnimationFrame(step);
    return () => cancelAnimationFrame(rafRef.current);
  }, [end, duration]);

  return value;
};
